module.exports = __webpack_public_path__ + "static/media/Crossley Kitchen Fridge Unit (2).0fe2a34b.jpg";